import XHeader from 'vux/src/components/x-header/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Radio from 'vux/src/components/radio/index.vue'


export default {
name:'contrastMaterial',
components: {
XHeader, XNumber, Group, Popup, Checklist, Radio
},
data () {
return {
quantity:1,
materialData:[],//材料


timePopup:false,
deliveryData:'',
deliveryList: [],
deliverySelected: '',//材料默认选中
delivery:'',//显示交期

materialIndex:0,//数据操作下标
}

},
methods: {


getMaterialList(){
this.$request.post('/quotation/compare',{
image: this.$route.query.imgurl,
length: this.$route.query.length,
width: this.$route.query.width,
height: this.$route.query.height,
volume: this.$route.query.volume,
unit: this.$route.query.unit,
deliveryDiscount: this.$route.query.deliveryDiscount,
quantity: 1,
colorId:this.$route.query.colorId,
colorName:decodeURI(this.$route.query.colorName),
deliveryDays:this.$route.query.deliveryDays,
}).then((response)=>{
console.log(response);
if(response.code == 0) {
this.materialData = response.obj;

this.getDelivery(response.obj[0].materialId);
}
})
},


getDelivery(materialId){
this.$request.post('/delivery/listDelivery',{'materialId':materialId}).then((response)=>{
console.log(response)
if(response.code == 0) {
this.deliveryData = response.obj;

for(let i=0; i<this.materialData.length; i++) {
this.materialData[i].deliveryDays = response.obj[0].days+'天';
}

this.deliverySelected = response.obj[0].days+'天'
for(let i=0; i<response.obj.length; i++) {
this.deliveryList.push(response.obj[i].days+'天');
}

}else{
this.$vux.toast.show({
type: 'warn',
text: response.msg
})
}

})
},


deliveryOpen(i){
this.materialIndex = i;
this.timePopup = true















},


deliveryChange (val, label) {
this.timePopup = false

if(this.materialData.length != 0) {
this.materialData[this.materialIndex].deliveryDays = label

let discount = '';
for(let i=0; i<this.deliveryData.length; i++) {
if(this.deliveryData[i].days == label[0].slice('天')[0]) {
discount = this.deliveryData[i].discount;
}
}


this.materialData[this.materialIndex].promotionTotal = (this.materialData[this.materialIndex].promotionTotal * (discount/100)).toFixed(1);

}

},

quantityChange(i,val){
console.log(i)
console.log(val)



this.materialData[i].promotionTotal = (this.materialData[i].promotionPrice * val).toFixed(1);

}
},

created () {

this.getMaterialList();
},
}


// WEBPACK FOOTER //
// ./src/views/contrastMaterial/script.js